import createVueApp from '@phoenix/createVueApp';

import PhxsgFocus from './phxsg-focus.vue';

document.querySelectorAll('[data-component="phxsg-focus"]').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgFocus', PhxsgFocus);
  app.mount(el);
});
